import React from "react";

export default function FilledHeart({ color = "#E25297", width = "25", height = "25" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1036_32386)">
        <path
          d="M21.9723 3.5115C20.8801 2.52993 19.4785 2.02275 18.0629 2.06493C16.3055 2.06493 14.5318 2.78681 13.2348 4.1265L12.3113 5.07665L11.3879 4.1265C10.0894 2.78681 8.31756 2.06493 6.55975 2.06493C5.14412 2.06493 3.74397 2.5304 2.61006 3.5115C-0.302755 6.0329 -0.448536 10.5287 2.1774 13.2427L11.2337 22.6037C11.5332 22.9102 11.9176 23.0649 12.3066 23.0649C12.6972 23.0649 13.089 22.9118 13.3852 22.6054L22.4368 13.2444C25.0707 10.5259 24.9254 6.03056 21.9723 3.5115ZM20.6828 11.5587L14.8515 11.679H11.8182C10.3069 10.1181 8.77358 15.0685 10.9298 13.2427C12.8001 11.6237 8.66632 11.302 9.92304 12.5991L12.3113 14.8495L16.7929 13.2444C18.0313 11.9661 12.9699 11.6169 14.8515 13.2444C16.9848 15.0936 19.8074 13.0637 20.6828 11.5587Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1036_32386">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.311035 0.564453)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}